import React from "react";
import { Form, Checkbox, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

const UICheckbox = ({
  label,
  name,
  defaultValue,
  disabled,
  tooltip,
  onSwitch = () => {},
}) => {
  return (
    <Form.Item
      name={name}
      valuePropName="checked"
      initialValue={!!defaultValue}
    >
      <Checkbox
        disabled={disabled}
        onChange={(e) => onSwitch(e.target.checked)}
      >
        {label}
        {tooltip && (
          <Tooltip title={tooltip}>
            <InfoCircleOutlined style={{ marginLeft: 8, color: "rgba(0,0,0,.45)" }} />
          </Tooltip>
        )}
      </Checkbox>
    </Form.Item>
  );
};

export default UICheckbox;
